<template>
<div name="subSystem card" class='panel bgPanel mt1x pb1x emptyToken_EE h24x'>
	<AddChildSys ref="AddChildSys" @refreshChildSys="refresh()" @update="update"/>
	<div class="title title-bg" style="margin-bottom:0">
		<span :title="getLanguageStr('plant_alert33','子系统')">{{getLanguageStr("plant_alert33","子系统")}}</span>
	</div>
	<div class="pl1x pr1x cb">
		<Select :name="'network'" :size="'m'"
						class='mr1x mt05x'
						:list="networkList"
						@Click='selectClickN'
						v-model="request.networkStatus"
						:bindActive="request.networkStatus"
						:keyMap="{text:'name',value:'value'}"/>
		<Select :name="'network'" :size="'m'"
						class='mr1x mt05x'
						:list="alertlist"
						 @Click='selectClickA'
						v-model="request.alertStatus"
						:bindActive="request.alertStatus"
						:keyMap="{text:'name',value:'value'}"/>
		<div class="fR dpIB_E vaM_E">
			<div class="classGroup cField_E tra-fast_E mr1x">
				<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in tabchild" @click="tabclick(item,index)" :key="index">{{item.datepicker}}</button>
			</div>
			<button class="functionBtn sizeM" @click="addNewChildSys" type="button">{{getLanguageStr('plant_detail230', '添加新子系统')}}</button>
		</div>
	</div>
	<div class="cb table">
		<Loading v-if='loadshow'/>
		<NoResult v-if='!data||data.length===0'/>
		<Generation v-show='ActiveIndex===0&&data.length>0' @changetree='changetree' :baseInfo='baseInfo' :requestData='request' ref='Generation'/>
		<Consumption v-show='ActiveIndex===1&&data.length>0' :baseInfo='baseInfo' :requestData='request' ref='Consumption'/>
	</div>
</div>
</template>
<script>
import { getLanguageStr } from '@/util/language'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import Generation from '@/view/maintain/light/plant/part/Generation.vue'
import Consumption from '@/view/maintain/light/plant/part/Consumption.vue'
import Select from '@/components/common/ui/Select.vue'
import AddChildSys from '@/components/common/ChildSysConfig.vue'
export default {
	name: 'powerplan',
	data () {
		return {
			stage,
			floatColumn: new Array(2),
			column: new Array(1),
			data: [],
			loadshow: false,
			request: {
				networkStatus: null,
				alertStatus: null,
				systemFunctionType: 'GENERATION'
			},
			alertlist: [{
				name: getLanguageStr('word1658', '报警状态'),
				value: null
			}, {
				name: getLanguageStr('word1465', '无报警'),
				value: 'NORMAL'
			}, {
				name: getLanguageStr('word1464', '有报警'),
				value: 'ALERTING'
			}],
			networkList: [{
				name: getLanguageStr('word1460', '通讯状态'),
				value: null
			}, {
				name: getLanguageStr('creat_plant40', '接入中'),
				value: 'NO_DEVICE'
			}, {
				name: getLanguageStr('plant_detail51', '全部设备离线'),
				value: 'ALL_OFFLINE'
			}, {
				name: getLanguageStr('plant_detail52', '部分设备离线'),
				value: 'PARTIAL_OFFLINE'
			}, {
				name: getLanguageStr('word1461', '通讯正常'),
				value: 'NORMAL'
			}],
			ActiveIndex: 0,
			tabchild: [{
				datepicker: getLanguageStr('plant_detail250', '发电'),
				type: 'generation'
			}, {
				datepicker: getLanguageStr('word561', '用电'),
				type: 'consumption'
			}]
		}
	},
	watch: {
		baseInfo (v) {
			this.changeBtn()
		}
	},
	props: ['baseInfo'],
	components: {NoResult, Loading, Generation, Consumption, Select, AddChildSys},
	methods: {
		getLanguageStr,
		changetree (item) {
			this.$emit('changetree', item)
		},
		setData (show, data) {
			this.loadshow = show
			this.data = data
		},
		update (id) {
			// this.$emit('refreshSelect')
			this.$bus.$emit('refreshSelect', this.baseInfo.id, id)
			this.changeBtn()
		},
		refresh () {
			this.$bus.$emit('refreshSelect', this.baseInfo.id)

			// this._getHeadInfo(this.baseInfo.id)
			this.$emit('addChildSysSuccess')
		},
		selectClickN (index, name) {
			this.request.networkStatus = this.networkList[index].value
			this.changeBtn()
		},
		selectClickA (index, name) {
			this.request.alertStatus = this.alertlist[index].value
			this.changeBtn()
		},
		changeBtn () {
			if (this.ActiveIndex === 0) {
				this.request.systemFunctionType = 'GENERATION'
				this.$nextTick(() => {
					this.$refs.Generation.getList()
				})
			} else {
				this.request.systemFunctionType = 'CONSUMPTION'
				this.$refs.Consumption.setaparam()
				this.$nextTick(() => {
					this.$refs.Consumption.getList()
				})
			}
		},
		tabclick (item, index) {
			this.ActiveIndex = index
			this.changeBtn()
		},
		addNewChildSys () {
			this.$refs.AddChildSys.show({
				id: this.baseInfo.id
			})
		}
	},
	mounted () {
		this.changeBtn()
	}
}
</script>
<style lang="scss" scoped>
.classGroup > *.active{
	background-color: transparent;
	color: $blueLight;
	border-bottom: 2px $blueLight solid;
}
.classGroup > *:first-child{
	border-radius: 0;
}
.classGroup > *:last-child{
	border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/ChildSysTab.vue